import { useTranslation } from 'react-i18next';
import {
  Table
} from '@sentara-health/optimahealth_web';

function SummaryTable({ summaryDetails }: any) {
  const { t } = useTranslation();
  return (
    <div className="table-responsive overflow-auto">
      <Table className="table no-header-table mb-3" headerChildren={null} rowsChildren={
        <>
          <tr>
            <td data-testid="memberName">
              {t('common.memberNameWithColon')}
            </td>
            <td data-testid="memberNameValue">{summaryDetails?.memberName}</td>
          </tr>
          <tr>
            <td data-testid="memberId">
              {t('common.memberIdWithColon')}
            </td>
            <td data-testid="memberIdValue">{summaryDetails?.memberId}</td>
          </tr>
          <tr>
            <td data-testid="totalCharges">
              {t('common.totalCharges')}
            </td>
            <td data-testid="totalChargesValue">
              {summaryDetails?.totalRequirement &&
                `$${summaryDetails?.totalRequirement}`}
            </td>
          </tr>
          <tr>
            <td data-testid="totalCovered">
              {t('common.totalCovered')}
            </td>
            <td data-testid="totalCoveredValue">
              {summaryDetails?.totalCovered && `$${summaryDetails?.totalCovered}`}
            </td>
          </tr>
          <tr>
            <th scope='col' data-testid="totalNotCovered">
              {t('common.totalNotCovered')}
            </th>
            <td data-testid="totalNotCoveredValue">
              {summaryDetails?.totalNotCovered &&
                `$${summaryDetails?.totalNotCovered}`}
            </td>
          </tr>
          <tr>
            <th scope='col' data-testid="totalDeductible">
              {t('common.totalDeductible')}
            </th>
            <td data-testid="totalDeductibleValue">
              {summaryDetails?.totalDeduction &&
                `$${summaryDetails?.totalDeduction}`}
            </td>
          </tr>
          <tr>
            <th scope='col' data-testid="totalCopayCoinsurance">
              {t('common.totalCopayCoinsurance')}
            </th>
            <td data-testid="totalCopayCoinsuranceValue">
              {summaryDetails?.totalCopay && `$${summaryDetails?.totalCopay}`}
            </td>
          </tr>
          <tr>
            <th scope='col' data-testid="totalPaidByPlan">
              {t('common.totalPaidByPlan')}
            </th>
            <td data-testid="totalPaidByPlanValue">
              {summaryDetails?.totalPaid && `$${summaryDetails?.totalPaid}`}
            </td>
          </tr>
          <tr>
            <th scope='col' data-testid="memberResponsibility">
              {t('viewTaxSummary.memberResponsibility')}
            </th>
            <td data-testid="memberResponsibilityValue">
              {summaryDetails?.totalResponsibility &&
                `$${summaryDetails?.totalResponsibility}`}
            </td>
          </tr>
        </>
      } />
    </div>

  );
}

export default SummaryTable;
